export const SECTORS = {
    noleggio_lungo_termine: {
        key: "noleggio_lungo_termine",
        label: "Noleggio Lungo Termine",
        tagline: "Auto aziendali e privati, tutto incluso",
        image: "https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=1600&q=80",
        accent: "#91C6C0",
    },
    energy_quoter: {
        key: "energy_quoter",
        label: "Energy Quoter",
        tagline: "Analisi AI di bollette luce e gas con proposta di risparmio",
        image: "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=1600&q=80",
        accent: "#C7FF2C",
    },
};

export const SECTOR_LABELS = {
    ...Object.fromEntries(
        Object.entries({
            noleggio_lungo_termine: "Noleggio Lungo Termine",
            energy_quoter: "Energy Quoter",
        }),
    ),
};

export const WIZARD_CONFIG = {
    noleggio_lungo_termine: [
        {
            title: "Anagrafica cliente",
            fields: [
                {
                    id: "tipo_cliente",
                    type: "single",
                    label: "Tipologia cliente",
                    options: ["Privato", "Partita IVA"],
                    required: true,
                },
                { id: "citta", type: "text", label: "Città / Provincia", required: true },
            ],
        },
        {
            title: "Preferenze veicolo",
            fields: [
                {
                    id: "categoria",
                    type: "multi",
                    label: "Categoria veicolo",
                    options: ["City car", "Berlina", "Station wagon", "SUV", "Crossover", "Furgone", "Premium"],
                    required: true,
                },
                {
                    id: "alimentazione",
                    type: "multi",
                    label: "Alimentazione",
                    options: ["Benzina", "Diesel", "Ibrida", "Plug-in Hybrid", "Elettrica", "GPL/Metano"],
                    required: true,
                },
                { id: "marca_modello", type: "text", label: "Marca/Modello preferito (opzionale)" },
            ],
        },
        {
            title: "Condizioni contratto",
            fields: [
                {
                    id: "durata",
                    type: "single_custom",
                    label: "Durata contratto",
                    options: ["25 mesi", "36 mesi", "48 mesi", "60 mesi"],
                    custom_placeholder: "Altra durata (es. 30 mesi)",
                    required: true,
                },
                {
                    id: "km_annui",
                    type: "single_custom",
                    label: "Km annui",
                    options: ["10.000", "15.000", "20.000", "25.000", "30.000+"],
                    custom_placeholder: "Altra percorrenza (es. 12.500)",
                    required: true,
                },
                {
                    id: "anticipo",
                    type: "anticipo",
                    label: "Anticipo",
                    required: true,
                },
            ],
        },
        {
            title: "Servizi inclusi",
            fields: [
                {
                    id: "servizi",
                    type: "multi",
                    label: "Servizi richiesti",
                    options: [
                        "Manutenzione ordinaria",
                        "Manutenzione straordinaria",
                        "Assicurazione Kasko",
                        "Furto & Incendio",
                        "RCA",
                        "Pneumatici stagionali",
                        "Auto sostitutiva",
                        "Bollo incluso",
                    ],
                },
            ],
        },
        {
            title: "Note aggiuntive",
            fields: [
                { id: "note", type: "textarea", label: "Informazioni aggiuntive" },
            ],
        },
    ],
};
